import { Component, OnInit } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { LogImportService } from "../../core/service/log-import.service";
import { finalize } from "rxjs/operators";
import { LogImport } from "../../core/model/log-import";

@Component({
  selector: "app-detail-importation",
  templateUrl: "./detail-importation.component.html",
  styleUrls: ["./detail-importation.component.scss"],
})
export class DetailImportationComponent implements OnInit {

  logImportId: string;
  isLoadingResults = true;
  logImport: LogImport = new LogImport();

  constructor(
    public activeModal: NgbActiveModal,
    private _logImportService: LogImportService
  ) {}
  ngOnInit() {
    this.logImportInfoById();
  }

  logImportInfoById() {
    this.isLoadingResults = true;
    this._logImportService
      .logImportInfoById(this.logImportId)
      .pipe(finalize(() => (this.isLoadingResults = false)))
      .subscribe(
        (data) => {
          this.logImport = data;
        },
        (error) => {
          console.log(error);
        }
      );
  }

}
